import React from 'react';
import {Container, FooterLink, WhiteTypography} from './FooterSharedStyles';

const LegalLinks = () => {
  return (
    <Container>
      <WhiteTypography variant='subheading2' component='span'>
        Rechtliches
      </WhiteTypography>
      <FooterLink
        href='https://support.fupa.net/support/solutions/articles/75000119348-nutzungsbedingungen-der-fupa-widgets-f%C3%BCr-webseitenbetreiber-nutzer-'
        target='_blank'>
        <WhiteTypography variant='body1'>Nutzungsbedingungen</WhiteTypography>
      </FooterLink>
      <FooterLink href='https://www.fupa.net/about/privacy-policy' target='_blank'>
        <WhiteTypography variant='body1'>Datenschutz</WhiteTypography>
      </FooterLink>
      <FooterLink href='https://www.fupa.net/about/legal-notice' target='_blank'>
        <WhiteTypography variant='body1'>Impressum</WhiteTypography>
      </FooterLink>
    </Container>
  );
};

export default LegalLinks;
